<template>
  <div class="serviceDetails">
    <el-form ref="form" :model="form" :rules="rules" :label-width="orderFlag ? '85px':'100px'">
      <template v-if="orderFlag">
        <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员姓名">{{curChooseRow.memberName}}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="手机号">{{curChooseRow.memberPhone}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预约时间">{{curChooseRow.scheduleStartTime | filterRow}}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="创建时间">{{curChooseRow.createTime | formatDateLine}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="lineH" label="预约项目">
            <span v-for="(i,index) in curChooseRow.serviceList" :key="index">{{i.serviceName}}{{curChooseRow.serviceList.length-1 == index ? '' : '，'}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="原员工">{{curChooseRow.technicianName}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否上门">{{curChooseRow.isHome == 1?'是':'否'}}</el-form-item>          
        </el-col>
        <el-col :span="10">
          <el-form-item label="上门地址" class="lineH" v-if="curChooseRow.isHome == 1">{{curChooseRow.serviceAddr}}</el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin:30px 0 20px;">
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <el-form-item label="新员工" prop="people">
            <el-select
              v-model="form.people"
              placeholder="请选择新员工"
              style="width:100%"
            >
              <el-option v-for='(i,index) in nthmenList' :key="index" :label="i.name" :value="i.authCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <el-form-item label="转单原因" prop="reason">
            <el-input
              type="textarea"
              v-model="form.reason"
              style="height:96px;"
              placeholder="请输入转单原因,100字以内"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </template>
      <template v-else>
        <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员姓名">{{curChooseRow.memberName | filterRow}}</el-form-item>
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号">{{curChooseRow.memberPhone}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="lineH" label="预约项目">
            <span v-for="(i,index) in curChooseRow.serviceList" :key="index">{{i.serviceName}}{{curChooseRow.serviceList.length-1 == index ? '' : '，'}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="15">
          <el-form-item label="预约时间">{{curChooseRow.scheduleStartTime | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <el-form-item label="创建时间">{{curChooseRow.createTime | formatDateLine}}</el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin:30px 0 20px;">
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="16">
          <el-form-item label="分配员工" prop="newPeople">
            <el-select
              v-model="form.newPeople"
              placeholder="请选择员工"
              style="width:100%"
            >
              <el-option v-for='(i,index) in allStaffList' :key="index" :label="i.staffName" :value="i.staffId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
          <el-form-item label="服务方式">{{curChooseRow.isHome == 1?'上门-'+curChooseRow.serviceAddr:'到店'}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
          <el-form-item label="留言">{{curChooseRow.message | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      </template>
      <el-row class="btnsOption">
        <el-button class="redBtn" @click="submitChange">提交</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { technicianList, allStaff, transferOrder, insertManualAssign } from "@/api";

export default {
  props: ['orderFlag','curChooseRow'],
  data() {
    return {
      form: {
        people:'',
        newPeople:'',
        reason:''
      },
      nthmenList:[],
      allStaffList:[],
      rules:{
        people:[
          { required: true, message: "请选择员工", trigger: "change" }
        ],
        newPeople:[
          { required: true, message: "请选择员工", trigger: "change" }
        ],
        reason: [
          {
            min: 0,
            max: 100,
            message: "长度在 100 个字符内",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.techList();
  },
  watch: {
    'orderFlag'(){
      this.techList();
      this.$refs.form.resetFields()
    },
    'curChooseRow'(){
      this.$refs.form.resetFields()
    }
  },
  // computed: {
  //   curNthmenList(){
  //     return this.allStaffList.filter(function (staff) {
  //       return staff.postId == 0
  //     })
  //   }
  // },  
  methods: {
    techList(){
      allStaff({
        status:'1',
        deleteFlag:'0',
        postId:'0'
      }).then(res=>{
        this.allStaffList = res.data;
      })
      technicianList({
        // status:'1',
        // deleteFlag:'0',
        // postId:'0'
      }).then(res=>{
        this.nthmenList = res.data;
      })
    },
    submitChange() {
      // 提交
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.orderFlag){
            // 转单
            transferOrder({
              orderServeId:this.curChooseRow.id,
              technicianAuthCode:this.form.people,
              remark:this.form.reason
            }).then(res=>{
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if(res.code == 1){
                this.$emit("closeDialog", false);
              }
            })
          }else{
            // 人工派单
            insertManualAssign({
              orderServeId:this.curChooseRow.id,
              technicianIdStore:this.form.newPeople,
            }).then(res=>{
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if(res.code == 1){
                this.$emit("closeDialog", false);
              }
            })
          }
        }else{
          console.log("error submit!!");
          return false;
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.serviceDetails {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.serviceDetails {
  .lineH {
    .el-form-item__content {
      line-height: 25px;
      padding-top: 8px;
    }
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
  }
  .el-form-item__content {
    text-align: left;
    color: #222;
  }
  .el-form-item__label {
    color: #666;
  }
  .btnsOption {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/businessManagementCenter/orderChange.vue